import styled from '@emotion/styled';

export const Container = styled.select`
  width: 100%;
  height: 40px;
  border-radius: 4px;
  outline: none;
`;
